import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

const FollowersListPage = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFollowers = async () => {
      try {
        const profileResponse = await api.get(`/users/${username}`);
        const response = await api.get(`/users/${profileResponse.data.id}/followers`);
        setFollowers(response.data);
      } catch (error) {
        toast.error("Unable to load followers.");
      } finally {
        setLoading(false);
      }
    };
    loadFollowers();
  }, [username]);

  return (
    <div className="space-y-6" data-testid="followers-list-page">
      <div>
        <h2 className="text-2xl font-semibold" data-testid="followers-list-title">Followers</h2>
        <p className="text-sm text-muted-foreground" data-testid="followers-list-subtitle">
          People following @{username}
        </p>
      </div>
      {loading ? (
        <div className="text-sm text-muted-foreground" data-testid="followers-list-loading">
          Loading followers...
        </div>
      ) : followers.length === 0 ? (
        <div className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" data-testid="followers-list-empty">
          No followers yet.
        </div>
      ) : (
        <div className="space-y-3" data-testid="followers-list">
          {followers.map((follower) => (
            <button
              key={follower.id}
              type="button"
              className="flex items-center gap-3 text-left"
              onClick={() => navigate(`/user/${follower.username}`)}
              data-testid={`followers-list-item-${follower.id}`}
            >
              <img
                src={follower.avatar_url}
                alt={follower.username}
                className="h-10 w-10 rounded-full object-cover"
              />
              <div>
                <div className="text-sm font-semibold">@{follower.username}</div>
                <div className="text-xs text-muted-foreground">{follower.full_name}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FollowersListPage;
